const EditorModalStates=['editing','display','pick-two'];export const isEditorModalState=state=>EditorModalStates.includes(state);